import React from 'react'

export default function FieldGoalType_DropdownValue(props:any) {

    const option = props.option;

    if (!option) return null;

    const optionColor = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;

    const classes = Classes("ui5-txt-less-important-small fl-ac txt-truncate", props.className, {
        "m-t-4 m-b-4": !props.field.noDefaultPaddingMargin
    })

    if (optionColor) {

        const pillClasses = Classes(
            "ui5-pillbox s26",
            "gd-c-bgp-"+optionColor,
            "gd-c-pale-border-"+optionColor,
            props.className
        )

        return (
            <div className={classes}>
                <div className={pillClasses}>
                    {option.label}
                </div>
            </div>
        )
    }

    const showIcon = _.get(props, 'configOptions.showIcon', true)

    let icon
    if (showIcon) {
        icon = _.get(props.field.components, 'ValueIcon', false)
        if (!icon && option.icon) {
            icon = <div className={Classes('ui5-ico-14 m-r-5', option.icon)}/>
        }
    }

    // no color
    return (
        <div className={classes}>
            {icon}
            <span className="txt-truncate">{option.label}</span>
        </div>
    );



}
